import ViewUtil from "../ViewUtil";
import Storage from "../protocol/Storage";
import { ALL_FILES_OPTION, ASSETS_TAB_ARGS, GLOBAL_SEARCH_INFO, IS_ASSET_SIDE_TREE_EXPANDED, SHOW_FOLDERNAV_VIEW } from "./Constants";
import Store from "./Store";

export class SetterStoreUtil {
  static setShowFolderNavView(value: boolean) {
    const showFolderNavView = Store.get(SHOW_FOLDERNAV_VIEW);
    if (value !== showFolderNavView) {
      Store.put(SHOW_FOLDERNAV_VIEW, value);
    }
  }

  static setAllFilesOption(value: boolean) {
    const allFileoptions = Store.get(ALL_FILES_OPTION);
    if (value !== allFileoptions) {
      Store.put(ALL_FILES_OPTION, value);
      if (!value) {
        ViewUtil.removeArg('type')
      } else {
        if(ViewUtil.isAssetTabActive()) {
          ViewUtil.removeArg('pwd')
          ViewUtil.setARGS({type: ASSETS_TAB_ARGS.ALL_FILES})
        }
      }
    }
  }

  static deactivateGlobalSearch() {
    if(Store.get(GLOBAL_SEARCH_INFO).active) {
      Store.put(GLOBAL_SEARCH_INFO, {active: false})
    } 
  }

  static setTreeExpanded(value: boolean) {
    const currentValue = Storage.get(IS_ASSET_SIDE_TREE_EXPANDED)
    const strValue = value.toString();
    if (currentValue !== strValue) {
      Storage.set(IS_ASSET_SIDE_TREE_EXPANDED, strValue);
    }
  }
}